export default __webpack_public_path__ + "static/media/sketch1.a902eb2f.jpg";